import { Injectable } from "@angular/core";

import { CommonState } from "../state";

@Injectable({
	providedIn: "root",
})
export class CampaignSelector {
	isBusy() {
		return (state: CommonState): boolean => state.campaign.isBusy;
	}
}
